import { render, staticRenderFns } from "./CmsCreate.vue?vue&type=template&id=3d6f3a20&"
import script from "./CmsCreate.vue?vue&type=script&lang=js&"
export * from "./CmsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports